import { DbOverwriteCargo } from "../../../data/usecases/overwrite-cargo";
import { OverwriteCargo } from "../../../domain/usecases/overwrite-cargo";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbOverwriteCargo = (): OverwriteCargo =>
  new DbOverwriteCargo(
    makeApiUrl("/cargo/overwrite"),
    makeAuthorizeHttpClientDecorator()
  );
